// @flow
import React from 'react';
import * as R from 'ramda';

import type {
  Entity,
} from 'chronos-types';

import {
  Flex,
} from '../../../../styled';

import {
  SidebarItemContainer,
  SidebarItemTitle,
  SidebarItemImage,
  SidebarItemSubtitle,
} from './styled';

type Props = {
  /**
   * Entity which was logged
   * */
  entity: Entity,
  /**
   * Sets whether the entity selected.
   * */
  selected: boolean,
  /**
   * Function that is called after entity selected.
   * */
  onSelect: () => {},
  /**
   * Function that is called when the entity clicked.
   * */
  onClick: { (id: string): void },
};
/**
 * SidebarEntityItem component responsible for rendering entity in Sidebar entity list
 * @version 1.0.0
 * @author [Alexander Hotovshchikov](https://github.com/hotovshchikov)
 */
const SidebarEntityItem = ({
  selected,
  onSelect,
  onClick,
  entity,
}: Props) => (
  <SidebarItemContainer
    selected={selected}
    onSelect={onSelect}
    onClick={() => onClick(R.path(['id'], entity))}
  >
    <Flex spacing={8} align="center">
      <SidebarItemImage
        src={R.path(['avatarUrls', '48x48'], entity)}
        alt="entity"
      />
      <SidebarItemTitle>
        {entity.name || entity.displayName}
      </SidebarItemTitle>
    </Flex>
    <SidebarItemSubtitle>
      {entity.emailAddress || entity.key}
    </SidebarItemSubtitle>
  </SidebarItemContainer>
);

SidebarEntityItem.defaultProps = {
  selected: false,
  onClick: () => {},
};

export default SidebarEntityItem;
